import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ProcessDataForExpress } from "../../../CommonFunction/ProcessDataForExpress";
import getExpressHeaders from "../../../CommonFunction/getExpressHeaders";
import { LoadTable, Loading } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import SearchBoxesDiv from "../../Components/HeaderDiv/HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";
import { ErrorToast } from "../../Components/ToastComponent/RectHotToast";
import useLazyFetch from "./UseLazyFetch";
const getCategoryFromTab = (tab) => {
  switch (tab) {
    case "Transporter_Logistics":
      return { Profile_Type: "Transporter_Logistics" };
    case "Company_Logistics":
      return { Profile_Type: "Company_Logistics" };
    case "Transporter_Broker":
      return { Profile_Type: "Transporter_Broker" };
    case "Shipper_Manufacturer_Trader":
      return { Profile_Type: "Shipper_Manufacturer_Trader" };
    case "Logistics_Booking_Business":
      return { Profile_Type: "Logistics_Booking_Business" };
    case "Company_Logistics":
      return { Profile_Type: "Company_Logistics" };
    case "Transporter_Commission_Agent":
      return { Profile_Type: "Transporter_Commission_Agent" };
    case "Fleet_Owner":
      return { Profile_Type: "Fleet_Owner" };
    case "Single_Truck_Owner_Driver":
      return { Profile_Type: "Single_Truck_Owner_Driver" };
    case "All":
      return {};
    default:
      return {};
  }
};

const EmtAccounts = () => {
  const title = "Emt_Accounts";

  let Refetch = useSelector((store) => store?.FormFieldData.refresh);
  const [Tab, SetTab] = useState("Transporter_Logistics");
  const [Key, setKey] = useState("EMT_Logistics");
  const dispatch = useDispatch();
  let statusTab = [
    { name: "Transporter_Logistics" },
    { name: "Company_Logistics" },
    { name: "Transporter_Broker" },
    { name: "Shipper_Manufacturer_Trader" },
    { name: "Logistics_Booking_Business" },
    { name: "Company_Logistics" },
    { name: "Transporter_Commission_Agent" },
    { name: "Fleet_Owner" },
    { name: "All" },
  ];

  const { data, loading, error, fetchData } = useLazyFetch(
    `${process.env.REACT_APP_CUSTOMER_SITE_BACKEND}/api/accounts/accountsWithProfileType`,
    getExpressHeaders(true)
  );

  useEffect(() => {
    const Tabdata = {
      key: title,
      data: Tab,
    };
    setKey(`EMT_${Tab}`);
    dispatch({ type: "UNIQUE_TAB_SELECT", payload: Tabdata });
    // popKey();
    // pushKey("EMT_Logistics");
    dispatch({ type: "Refetch", payload: true }); // Trigger the lazy query when Refetch changes
  }, [Tab]);

  useEffect(() => {
    const selectedCategory = getCategoryFromTab(Tab);
    if (Refetch) {
      fetchData(selectedCategory);
      dispatch({ type: "Refetch", payload: false });
    }
  }, [Refetch, Tab]); // Add Tab to the dependencies

  const config = useMemo(
    () => ({
      dataKey: `data`,
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["__typename"],
    }),
    []
  );

  useEffect(() => {
    if (error) {
      ErrorToast(error);
    }
  }, [error]);

  const formData = useMemo(() => {
    // console.log(data);
    return data?.length ? ProcessDataForExpress(data, config) : [];
  }, [data]);



  return (
    <div className="LoadContainer">
      <div className="HeaderDiv">
        <div>
          <p className="pageTitle">EMT Accounts</p>
          <div className="hr1ForPageTitle"></div>
        </div>
        <SearchBoxesDiv />
      </div>

      <Tabs tabs={statusTab} SetTabPage={SetTab} />

      <HeaderDiv title={""} MoreActions={{ Is_Merge: true, Send_Notification: true }} TableKey={"Emt_Accounts"} />

      {/* 1) If loading and you have NO data yet, show a big loader */}
      {loading && (!data || data.length === 0) && <Loading />}

      {/* 2) If not loading but data array is empty, show "Data Not Available" */}
      {!loading && (!data || data.length === 0) && <p className="DataNotAvailable">Data not Available</p>}

      {/* 3) If we DO have data, show the table */}
      {data && data.length > 0 && (
        <>
          {/* 4) If re-fetching (loading again) but we already have data, show inline loader */}
          {loading && <div className="loader-line-div" />}

          <LoadTable data={formData} loading={""} error={error} title={"Emt_Accounts"} Tab={Key} />
        </>
      )}
    </div>
  );
};

export default EmtAccounts;
